import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { auth, db } from '../../../firebase';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { TranslatedText } from '../../i18n/TranslatedText.jsx';
import { useTranslatedText } from '../../i18n/useTranslatedText.js';
import './RegisteredUsers.css';

const RegisteredUsers = () => {
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const loadingText = useTranslatedText('Yükleniyor...');
  const registeredForText = useTranslatedText('etkinliğine kayıtlı kişiler');
  const ageText = useTranslatedText('Yaş:');
  const emailText = useTranslatedText('E-posta:');

    useEffect(() => {
        const checkAuthAndFetchData = async () => {
            try {
                // Wait for auth state to initialize
                await new Promise((resolve) => {
                    const unsubscribe = auth.onAuthStateChanged((user) => {
                        unsubscribe();
                        resolve(user);
                    });
                });

                // Check if user is authenticated
                if (!auth.currentUser) {
                    navigate('/');
                    return;
                }

                // Fetch event data
                const eventDoc = await getDoc(doc(db, 'events', eventId));
                
                if (!eventDoc.exists()) {
                    navigate('/');
                    return;
                }

                const eventData = eventDoc.data();

                // Check if current user is the event owner
                if (eventData.createdBy !== auth.currentUser.uid) {
                    navigate('/');
                    return;
                }

                setEvent(eventData);

                // Fetch registered users' details from subcollection (more private than global user docs)
                try {
                    const registrationsSnap = await getDocs(collection(db, 'events', eventId, 'registrations'));
                    const usersData = registrationsSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
                    if (usersData.length > 0) {
                        setRegisteredUsers(usersData);
                    } else if (Array.isArray(eventData.registeredUsers) && eventData.registeredUsers.length > 0) {
                        setRegisteredUsers(eventData.registeredUsers.map((id) => ({ id })));
                    }
                } catch (error) {
                    console.error('Error fetching registrations:', error);
                    if (Array.isArray(eventData.registeredUsers) && eventData.registeredUsers.length > 0) {
                        setRegisteredUsers(eventData.registeredUsers.map((id) => ({ id })));
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                navigate('/');
            } finally {
                setLoading(false);
            }
        };

        checkAuthAndFetchData();
    }, [eventId, navigate]);

  if (loading) return <div>{loadingText}</div>;

  return (
    <div className="registered-users">
      <h2>
        <TranslatedText text={event?.name ?? ''} dynamic />
        {' '}
        {registeredForText}
      </h2>
      <div className="users-grid">
        {registeredUsers.map((user) => (
          <div key={user?.id} className="user-card">
            <h3>{user?.username || user?.id}</h3>
            {user?.age != null && <p>{ageText} {user.age}</p>}
            {user?.email && <p>{emailText} {user.email}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegisteredUsers;
